export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_29-2d0fc487beb65d73018ea499dd506878.jpg";